import Cookies from "js-cookie";
import requestHandler from "./requestHandler";

export default {
    getCRSF(fetchNewXsrfToken = false) {
      if(fetchNewXsrfToken || !Cookies.get('XSRF-TOKEN'))
        return requestHandler.get("sanctum/csrf-cookie");
    }
};